/** Restore the opener after native close settles, unless the user has already moved focus. */
export function restoreDialogFocus(
  opener: HTMLElement | null,
  dialog?: HTMLDialogElement | null,
): void {
  const activeWhenQueued = document.activeElement;
  requestAnimationFrame(() => {
    if (!opener?.isConnected || dialog?.open) return;
    const active = document.activeElement;
    if (
      active !== activeWhenQueued &&
      active !== document.body &&
      !(active && dialog?.contains(active))
    )
      return;
    opener.focus({ preventScroll: true });
  });
}
